import { Activity } from '@cms-max/medicare-api-sdk'
import generator, { EventMapKeys } from './baseGenerator'

export const claimsEventGenerator = generator(({ i18n }) => {
  const ns = 'claims'
  return ({
    // Claims Order MSN Link Click
    claims_openorderMSN_click: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Claims',
        elementId: 'claims_openorderMSN_click',
        coreClickData: {
          linkText: i18n.t('information.orderMSNLink', { ns })
        }
      }
    },
    // Claims Duplicate MSN Cancel Click
    claims_duplicatemsncancel_button: {
      core: {
        property: 'MAX',
        activity: Activity.ButtonClick,
        component: 'Claims',
        elementId: 'claims_duplicatemsncancel_button'
      }
    }
  })
})

export type ClaimsKeys = EventMapKeys<typeof claimsEventGenerator>

export default claimsEventGenerator
